import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import Slider from '../../../common/Slider/Slider';
import ProBadge from '../../../common/ProBadge/ProBadge';
import PlaceholderImage from '../../../common/placeholderImage/PlaceholderImage';

// @TODO join this and the PromotionsSliderComponent and also the corresponding scss files

const BASE = 'https://a1media.antena1.com.br/image/promocao';

class PromotionsSlider extends Component {
    _mapPromotions() {
        const promotions = this.props.promotions;
        const fullVersion = this.props.fullVersion;

        // DEFINE  CLASS TO S BODY SLIDER
        const bodySliderConfig = fullVersion ? 'bodySliderConfigFeatured' : 'bodySliderConfig';

        const styleToLessThreeImage = !fullVersion && this.props.slidesToShowExtraLarge === 1 ? 'singleSlider'// define class quando só tem uma promção
            : !fullVersion && this.props.slidesToShowExtraLarge === 2 ? 'doubleSlider' : '';// define class quando só tem duas promção

        const widthImag = styleToLessThreeImage === 'singleSlider' ? 'sizeImg' : '';

        return promotions.map((item, index) => {
            let imgSrc; let imgSrcSet; let
                imgSizes;

            if (fullVersion) {
                if (item.tx_featuredImageNew) {
                    const img = encodeURI(item.tx_featuredImageNew);
                    imgSrc = `${BASE}/1920x800/${img}`;
                    imgSrcSet = `${BASE}/576x240/${img} 576w, ${BASE}/768x320/${img} 768w, ${BASE}/992x413/${img} 992w, ${BASE}/1920x800/${img} 1920w`;
                    imgSizes = '(max-width: 575px) 576px, (max-width: 767px) 768px, (max-width: 991px) 992px, 1920px';
                } else {
                    imgSrc = `${BASE}/${item.tx_banner_destaque}`;
                }
            } else if (item.tx_imageNew) {
                const img = encodeURI(item.tx_imageNew);
                imgSrc = `${BASE}/752x392/${img}`;
                imgSrcSet = `${BASE}/560x292/${img} 560w, ${BASE}/752x392/${img} 752w`;
                imgSizes = '(max-width: 767px) 560px, 752px';
            } else {
                imgSrc = `${BASE}/${item.tx_banner}`;
            }

            const colorStyle = item.tx_colorScheme === 'D' ? { color: '#666' } : { color: 'white' };
            const showContentStyle = this.props.isTablet != null ? { opacity: '1 !important' } : {};
            const pro = !!item.pro;

            return (
                // eslint-disable-next-line react/no-array-index-key
                <div className="slideWrapper" key={index}>
                    {pro && !fullVersion && <ProBadge className="promotionSliderProBadge" title="pro" />}
                    <Button className="linkToPromotion" title={item.tx_promocao} to={`/promocoes/${item.url_promocao}`}>
                        <div className={`bodySlider ${styleToLessThreeImage} ${bodySliderConfig}`}>
                            <div className={widthImag}>
                                <PlaceholderImage
                                    src={imgSrc}
                                    srcSet={imgSrcSet}
                                    sizes={imgSizes}
                                    alt={`Banner da promoção ${item.tx_promocao}`}
                                    placeholderHeight="100%"
                                    placeholderWidth="100%"
                                />
                            </div>
                            {fullVersion ? (
                                <div className="content">
                                    {pro && <ProBadge className="promotionSliderTitleProBadge" title="pro" />}
                                </div>
                            ) : (
                                <div>
                                    <div style={showContentStyle} className="contentNormalSlide">
                                        <h2 style={colorStyle}>
                                            {item.tx_promocao}
                                        </h2>
                                    </div>
                                    <div style={showContentStyle} className={`${styleToLessThreeImage} shadow`} />
                                </div>
                            )}
                        </div>
                    </Button>
                </div>
            );
        });
    }

    render() {
        const spaceBetween = this.props.fullVersion ? 0 : 30;
        const autoPlay = this.props.autoplay ? {
            delay: this.props.speed,
        } : false;

        return (
            <div className={`sliderPromotions${this.props.fullVersion ? ' fullVersion' : ''}`}>
                {
                    this.props.promotions && (
                        <Slider
                            autoplay={autoPlay}
                            slidesPerView={this.props.slidesToShowExtraSmall}
                            spaceBetween={spaceBetween}
                            loop={this.props.infinite}
                            navigation={this.props.navigation}
                            pagination={this.props.pagination}
                            speed={this.props.speed}
                            breakpoints={{
                                768: {
                                    slidesPerView: this.props.slidesToShowSmall,
                                },
                                992: {
                                    slidesPerView: this.props.slidesToShowMedium,
                                },
                                1200: {
                                    slidesPerView: this.props.slidesToShowLarge,
                                },
                            }}
                        >
                            {this._mapPromotions()}
                        </Slider>
                    )
                }
            </div>
        );
    }
}

PromotionsSlider.propTypes = exact({
    /* eslint-disable react/no-unused-prop-types */
    width: PropTypes.string,
    height: PropTypes.string,
    'min-height': PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    dots: PropTypes.bool,
    autoplaySpeed: PropTypes.number,
    slidesToScroll: PropTypes.number,
    swipeToSlide: PropTypes.bool,
    useCSS: PropTypes.bool,
    cssEase: PropTypes.string,
    centerMode: PropTypes.bool,
    slidesToShow: PropTypes.number,
    /* eslint-enable react/no-unused-prop-types */
    infinite: PropTypes.bool,
    pagination: PropTypes.bool,
    navigation: PropTypes.bool,
    autoplay: PropTypes.bool,
    speed: PropTypes.number,
    promotions: PropTypes.array.isRequired,
    slidesToShowExtraSmall: PropTypes.number,
    slidesToShowSmall: PropTypes.number,
    slidesToShowMedium: PropTypes.number,
    slidesToShowLarge: PropTypes.number,
    slidesToShowExtraLarge: PropTypes.number,
    isTablet: PropTypes.string,
    fullVersion: PropTypes.bool,
});

PromotionsSlider.defaultProps = {
    width: 'inherit',
    height: 'inherit',
    infinite: false,
    dots: false,
    autoplay: false,
    autoplaySpeed: 1000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: false,
    useCSS: true,
    cssEase: 'linear',
    centerMode: false,
    slidesToShowExtraSmall: 2,
    slidesToShowSmall: 3,
    slidesToShowMedium: 4,
    slidesToShowLarge: 5,
    slidesToShowExtraLarge: 6,
    fullVersion: false,
    pagination: false,
    navigation: false,
};

export default PromotionsSlider;
